export default {
    home: '首页',
    aboutUs: '关于锐合',

    assessServe: '风险合规咨询服务',
    regulatoryCompliance: '监管合规',
    riskManagement: '风险管理',
    strategyAndOperation: '战略与运营',



    teleProduct: '监管科技产品',
    complianceManagement: '合规管理',
    newSomething: '新技术和新趋势',
    libraryAndSetting: '图书馆和工具箱',
    

    contactUs: '联系我们',
    news_d:'新闻中心',
    ruike:'锐课学院',
    talentRecruitment: '人才招聘',
}